import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { ToggleSwitch } from "./ToggleSwitch"


export const ActivateFeatures = ({ features, activate }) => {
    return (
        <VerticalLayout className={"feature-card activate-feature"} style={{ padding: 0 }}>
            <TextAtom title="Activeer functionaliteiten" className={"feature-title"} style={{
                padding: "1rem",
       
                paddingBottom: "1.5rem"
            }} />
            <VerticalLayout class="space-between">
                {features.map((feature, index) => (
                    <FeatureCard key={index} feature={feature} activate={() => activate(index)} />
                ))}
            </VerticalLayout>
        </VerticalLayout>
    )
}

const FeatureCard = ({ feature, activate }) => {
    return (
        <HorizontalLayout className="space-between feature-card-2">
            <VerticalLayout>
                <TextAtom title={feature.name} className="feature-name" />
                <TextAtom title={feature.description} className="feature-description" />
            </VerticalLayout>
            <>
            {!feature.checked && feature.owned  ? <TextAtom title={`aflopend contract: \n ${feature.end_date}`}/>:<></>}
            <ToggleSwitch checked={feature.checked} onChange={activate} />
            </>
        </HorizontalLayout>

    )
}
